<template>
  <!-- 基础信息 -->
  <div class="ticket-detail" ref="ticketDetailRoot">
    <!-- 多语言切换按钮（仅当配置开关打开 + 当前流程在白名单时显示）；
         始终挂载，等 ProcessDefinitionKey 到达时按需启用，避免父级 v-if 阻断初始化 -->
    <LanguageSwitcher
      :processDefinitionKey="ticketData.ProcessDefinitionKey || ''"
      :rootEl="translateRoot"
      :tz-enabled="isTimezoneEnabled"
      :tz-mode="tzCurrentMode"
      :tz-timezone="tzSystemTimezone"
      @tz-switch-local="tzSwitchToLocal"
      @tz-switch-beijing="tzSwitchToBeijing"
    />

    <h3 :style="{ margin: shouldUseCollapse ? '4px' : '' }">
      {{ title || ticketBaseData.Title }}
    </h3>

    <TicketInfo
      v-if="ticketData.TicketId"
      :ticketData="ticketData"
      :todoComponent="todoComponentData"
      :shouldUseCollapse="shouldUseCollapse"
      :schemeData="schemeData"
    />

    <TodoOperation
      v-if="ticketData.TicketStatus && !isHistory"
      @title-change="(val) => (title = val)"
      @update-todo-component="updateTodoComponent"
      @scheme-data-loaded="updateSchemeData"
      :instanceId="ticketData.InstanceId"
      :ticketId="ticketId"
      :todoId="taskId"
      :isSim="isSim"
      :ticketDealer="ticketDealer"
      :ticketStatus="ticketData.TicketStatus"
      :shouldUseCollapse="shouldUseCollapse"
    />
    <TodoHistory
      v-if="ticketData.TicketStatus && isHistory"
      @title-change="(val) => (title = val)"
      :instanceId="ticketData.InstanceId"
      :ticketId="ticketId"
      :taskId="taskId"
      :ticketStatus="ticketData.TicketStatus"
    />
  </div>
</template>

<script>
import TicketInfo from './ticketInfo-new.vue';
import TodoOperation from './complexTodo-new';
import TodoHistory from './complexDone';
import LanguageSwitcher from '@/components/LanguageSwitcher/index.vue';
import timezoneMixin from '@/utils/timezoneMixin';
import { isTimezoneEnabled } from '@/utils/timezoneGate';
import { mapGetters } from 'vuex';

import { getTicketData } from '@/api/tickets/ticketsApi';
export default {
  name: 'TicketDetail',
  mixins: [timezoneMixin],
  components: {
    TicketInfo,
    TodoOperation,
    TodoHistory,
    LanguageSwitcher,
  },
  watch: {
    ticketData: {
      handler(newVal, oldVal) {
        // console.log('ticketData==>', newVal);
      },
    },
  },
  created() {

    this.getTicketData(this.ticketId);
  },
  mounted() {
    // 翻译作用范围设为当前页面根元素，避免影响外部
    this.translateRoot = this.$refs.ticketDetailRoot || document.body;
  },
  data() {
    return {
      ticketId: this.$route.query.ticketId || this.$route.query.params,
      taskId: this.$route.query.taskId,
      ticketData: {},
      ticketBaseData: {},
      title: '',
      isSim: false,
      isHistory: this.$route.query.isHistory === '1',
      todoComponentData: [],
      schemeData: null,
      translateRoot: null,
    };
  },
  computed: {
    ...mapGetters(['getConfigItem']),
    /** 时区转换灰度判定：详情页需要传流程标识 */
    isTimezoneEnabled() {
      return isTimezoneEnabled({
        getConfigItem: this.getConfigItem,
        processDefinitionKey: this.ticketData.ProcessDefinitionKey || '',
      });
    },
    ticketDealer() {
      return (this.ticketData.UserInfo || [])
        .filter((item) => item.UserType === 'creator' || item.UserType === 'concern')
        .map((item) => item.Username)
        .concat(this.ticketData.Manager.split(';'))
        .concat(this.ticketData.CurrentAllProcessUsers.split(','));
    },
    shouldUseCollapse() {
      try {
        // const testSchemeIds = JSON.parse(this.getConfigItem('test_scheme_id'));
        // console.log('this.ticketData==>',this.ticketData);

        const testSchemeIds = JSON.parse(this.getConfigItem('mobile_process_definition_Key_css'));
        // console.log('testSchemeIds==>',testSchemeIds.includes(this.ticketData.ProcessDefinitionKey));

        return testSchemeIds && testSchemeIds.includes(this.ticketData.ProcessDefinitionKey);
      } catch (error) {
        // console.error('解析mobile_process_definition_Key_css失败:', error);
        return false;
      }
    },
  },
  methods: {
    updateTodoComponent(todoComponent) {
      this.todoComponentData = todoComponent;
    },
    updateSchemeData(schemeData) {
      this.schemeData = schemeData;
    },
    async getTicketData(TicketId) {
      try {
        this.loading = true;
        const ticketResult = await getTicketData({
          ResultColumns: {
            AdditionInfo: '',
            CreateTime: '',
            CurrentTasks: '',
            CustomKV: '',
            CustomRequestVarKV: '',
            Description: '',
            EndTime: '',
            EventInfo: '',
            ExceptionEndTaskId: '',
            InstanceId: '',
            IsForceEnd: '',
            NdvInfo: '',
            NetFaultRecoverTime: '',
            ProcessDefinitionKey: '',
            SceneType: '',
            SchemeNameCn: '',
            SLALevel: '',
            ServiceRecoverTime: '',
            StartProcessTime: '',
            StatusTag: '',
            TicketId: '',
            TicketStatus: '',
            Title: '',
            UserInfo: '',
            SchemeId: '',
            ForceEndReason: '',
            ForceEndOperator: '',
            OutputResultDatas: '',
            CurrentAllProcessUsers: '',
            Manager: '',
          },
          SearchCondition: { TicketId },
        });

        const { List } = ticketResult.data;

        const [data] = [...List];
        this.ticketData = data || {};
        // 存储流程标识
        this.$store.state.config.ProcessDefinitionKey = data?.ProcessDefinitionKey;
        // 基本信息编辑
        this.ticketBaseData.Title = data.Title;
        this.ticketBaseData.Description = data.Description;
        if (
          this.ticketData.CustomRequestVarKV.some(
            (item) => item.Key === 'isOriginTicket' && item.Value === 'isOriginTicket'
          )
        ) {
          this.isSim = true;
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@primary: #0052d9;
@primary-lighter: #ecf2fe;
@bg-page: #f5f6f7;
@bg-white: #ffffff;
@text-primary: #181b22;
@text-secondary: #86909c;
@border-light: #f0f1f3;
@radius-md: 10px;
@shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.04);

.ticket-detail {
  min-height: 100vh;
  overflow-y: auto;
  background-color: @bg-page;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;

  > h3 {
    font-size: 15px;
    font-weight: 600;
    color: @text-primary;
    padding: 12px 14px 8px;
    margin: 0;
    line-height: 1.4;
    background: @bg-white;
    word-break: break-all;
    text-align: center;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: @border-light;
    }
  }
}
</style>

<!-- 页面级 RTL 适配：阿拉伯语等场景，反转整体布局方向 -->
<!-- 注意：dir 属性现在仅设在 .ticket-detail 容器上，不再污染 <html>/<body>，
     所以选择器全部基于 .ticket-detail[dir='rtl'] 或 .ticket-detail[dir='rtl'] ... 子级 -->
<style lang="less">
.ticket-detail[dir='rtl'] {
  direction: rtl;
  text-align: right;
}
.ticket-detail[dir='rtl'] > h3 {
  text-align: center;
}
/* vant 部分组件横向布局在 RTL 下需要镜像 */
.ticket-detail[dir='rtl'] .van-cell__title,
.ticket-detail[dir='rtl'] .van-cell__value {
  text-align: right;
}
.ticket-detail[dir='rtl'] .van-field__label {
  text-align: right;
}
</style>
